import React, { FC, useMemo } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { getCouponsInfo } from '@utils'
import { format, toPrice } from '@dt/fe-utils'
import { keyBy, find } from '@dt/fe-utils/dist/lodash'
import './cardItem.scss'

import cardBg from '@img/member/card-bg.png'

interface IProps {
  cardInfo: any;
  type: 'mall' | 'meal';
}

const CardItem: FC<IProps> = (props: IProps) => {
  const { cardInfo, type } = props
  const actionCnt: number = useMemo(() => {
    let cnt: number = 0
    if (cardInfo?.isSendCoupon && cardInfo?.couponPolicys?.length > 0) {
      const info = keyBy(cardInfo.couponPolicys, 'sendType')
      if (info.action) cnt = getCouponsInfo(info.action.coupons, 'cnt')
    }
    return cnt
  }, [cardInfo])
  const getFavorablePrice = (scales: any[]) => {
    const recommend = find(scales, (item) => item.ifRecommend)
    if (recommend) {
      return (
        <>
          <span>{recommend.type === 'customize' ? i18n.t('mkt.member.days', { number: recommend.validDays }) : i18n.t(`mkt.member.${recommend.type}`)} </span>
          <span>{toPrice(recommend.price || 0)}</span>
        </>
      )
    } else {
      const info = scales[0] || null
      return (
        info ? (
          <>
            <span>{info.type === 'customize' ? i18n.t('mkt.member.days', { number: info.validDays }) : i18n.t(`mkt.member.${info.type}`)} </span>
            <span style={info?.activityProducts?.activityPrice ? { textDecoration: 'line-through', marginRight: '4px' } : {}}>{toPrice(info.price || 0)}</span>
            {info?.activityProducts?.activityPrice && <span>{toPrice(info.activityProducts.activityPrice || 0)}</span>}
          </>
        ) : null
      )
    }
  }
  return (
    <div
      className='get-card-recommend'
      style={{
        color: cardInfo?.extra?.fontColor || '#B8B8B8',
        borderRightColor: cardInfo?.extra?.fontColor || '#B8B8B8'
      }}
    >
      <div className='mci-content' style={{ backgroundImage: `Url(${cardInfo.cover || cardBg})` }}>
        <div className='mci-content-l'>
          <div className='mci-header'>
            <div className='mci-header-top'>
              <div className='name'>{cardInfo.cardName}</div>
              <div
                className='open-btn'
                style={{
                  color: cardInfo?.extra?.btnFontColor || '#251E1E',
                  background: cardInfo?.extra?.btnColor || '#B8B8B8'
                }}
              >{i18n.t('mkt.member.toOpen')}<i className='iconfont icon-chevron-right'></i>
              </div>
            </div>
            {!!cardInfo?.scales?.length &&
              <div className='price'>{getFavorablePrice(cardInfo.scales)}</div>}
          </div>
        </div>
        <div className='detail-info'>
          <div className='detail-info-top'>
            {
              cardInfo.thriftOff
                ? <span>{i18n.t('mkt.member.saveMoney')}<span className='coupon-num'>{toPrice(cardInfo.thriftOff)}</span></span>
                : (
                  <>
                    <span>{i18n.t('mkt.member.enjoyDis')}</span>
                    {
                      cardInfo.discountType && cardInfo.mallDiscountType
                        ? (
                          <>
                            {
                              type === 'mall'
                                ? <span className='coupon-num'>{i18n.t('order.mall')}{cardInfo.mallDiscountType === 'memberPrice' ? i18n.t('checkout.memberPrice') : format.toDiscount('discountRate', cardInfo.mallDiscountValue)}</span>
                                : <span className='coupon-num'>{i18n.t('order.meals')}{cardInfo.discountType === 'memberPrice' ? i18n.t('checkout.memberPrice') : format.toDiscount('discountRate', cardInfo.discountValue)}</span>
                            }
                          </>
                        ) : (
                          <>
                            {cardInfo.discountType === 'memberPrice' &&
                              <span className='coupon-num'>{i18n.t('order.meals')}{i18n.t('checkout.memberPrice')}</span>}
                            {
                              cardInfo.discountType === 'discountRate' &&
                                <span className='coupon-num'>{cardInfo?.products?.length ? i18n.t('mkt.member.someMeals') : i18n.t('order.meals')}{format.toDiscount('discountRate', cardInfo.discountValue)}</span>
                            }
                            {
                              cardInfo.mallDiscountType === 'memberPrice' &&
                                <span className='coupon-num'>{i18n.t('order.mall')}{i18n.t('checkout.memberPrice')}</span>
                            }
                            {
                              cardInfo.mallDiscountType === 'discountRate' &&
                                <span className='coupon-num'>{cardInfo?.mallProducts?.length ? i18n.t('mkt.member.someMall') : i18n.t('order.mall')}{format.toDiscount('discountRate', cardInfo.mallDiscountValue)}</span>
                            }
                          </>
                        )
                    }
                  </>)
            }
            {actionCnt > 0 && <span className='coupon-num'>{i18n.t('mkt.member.coupons', { num: actionCnt })}</span>}
          </div>
          <div className='detail-info-content'>
            {cardInfo.discountType === 'memberPrice' && type !== 'meal' &&
              <span>{i18n.t('order.meals')}:{i18n.t('checkout.memberPrice')}</span>}
            {
              cardInfo.discountType === 'discountRate' && type !== 'meal' &&
                <span>{cardInfo?.products?.length ? i18n.t('mkt.member.someMeals') : i18n.t('order.meals')}:{format.toDiscount('discountRate', cardInfo.discountValue)}</span>
            }
            {
              cardInfo.mallDiscountType === 'memberPrice' && type !== 'mall' &&
                <span>{i18n.t('order.mall')}:{i18n.t('checkout.memberPrice')}</span>
            }
            {
              cardInfo.mallDiscountType === 'discountRate' && type !== 'mall' &&
                <span>{cardInfo?.mallProducts?.length ? i18n.t('mkt.member.someMall') : i18n.t('order.mall')}:{format.toDiscount('discountRate', cardInfo.mallDiscountValue)}</span>
            }
            {
              cardInfo.isIntegral &&
                <span>{i18n.t('mkt.member.consumeGetInt')}</span>
            }
            {
              (cardInfo.allowAgainLoad || cardInfo.allowCustomizeLoad) &&
                <span>{i18n.t('mkt.member.storedValue')}</span>
            }
            {
              cardInfo.isLevel &&
                <span>{i18n.t('mkt.member.canCardGrowth')}</span>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(CardItem)
